(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rh-card"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__sdQuickAdd) return;
    window.__sdQuickAdd = true;

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    function closeAll(except) {
      document.querySelectorAll('[data-sd-qa].is-open').forEach(function (qa) {
        if (qa === except) return;
        qa.classList.remove('is-open');
        var p = qa.querySelector('.sd-qa__panel');
        if (p) p.hidden = true;
        var o = qa.querySelector('[data-sd-open]');
        if (o) o.setAttribute('aria-expanded', 'false');
      });
    }

    function flash(qa, text) {
      var main = qa.querySelector('.sd-qa__btn');
      var label = main && main.querySelector('.sd-qa__text');
      if (!label) return;
      var original = label.getAttribute('data-original') || label.textContent;
      label.setAttribute('data-original', original);
      label.textContent = text;
      qa.classList.add('is-added');
      clearTimeout(qa.__sdTimer);
      qa.__sdTimer = setTimeout(function () {
        label.textContent = original;
        qa.classList.remove('is-added');
      }, 2000);
    }

    async function addToCart(btn) {
      var qa = btn.closest('[data-sd-qa]');
      if (!qa || btn.disabled || qa.classList.contains('is-loading')) return;
      var id = btn.getAttribute('data-sd-add');
      qa.classList.add('is-loading');

      var sectionIds = Array.prototype.map.call(document.querySelectorAll('cart-items-component'), function (el) {
        return el.dataset.sectionId;
      }).filter(Boolean);

      var ev = null;
      var deferred = null;
      try { ev = await import('@shopify/events'); } catch (e) { ev = null; }
      if (ev && ev.CartLinesUpdateEvent) {
        deferred = ev.CartLinesUpdateEvent.createPromise();
        btn.dispatchEvent(new ev.CartLinesUpdateEvent({
          action: 'add',
          context: 'product',
          lines: [{ merchandiseId: id, quantity: 1 }],
          promise: deferred.promise
        }));
      }

      try {
        var res = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }], sections: sectionIds.join(',') })
        });
        var data = await res.json();
        var cart = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });

        if (data.status) {
          if (deferred) deferred.resolve({ cart: ev.CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { didError: true, items: cart.items, source: 'sd-quick-add', sourceId: 'sd-quick-add', itemCount: 1 } });
          flash(qa, 'Sin stock');
          return;
        }

        if (deferred) {
          deferred.resolve({ cart: ev.CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { didError: false, items: cart.items, source: 'sd-quick-add', sourceId: 'sd-quick-add', itemCount: 1, sections: data.sections } });
        } else {
          window.location.href = root + 'cart';
          return;
        }
        closeAll();
        flash(qa, 'Añadido ✓');
      } catch (err) {
        if (deferred) deferred.reject(err);
        window.location.href = root + 'cart';
      } finally {
        qa.classList.remove('is-loading');
      }
    }

    document.addEventListener('click', function (e) {
      var target = e.target;
      if (!(target instanceof Element)) return;

      var close = target.closest('[data-sd-close]');
      if (close) { e.preventDefault(); closeAll(); return; }

      var open = target.closest('[data-sd-open]');
      if (open) {
        e.preventDefault();
        var qa = open.closest('[data-sd-qa]');
        var panel = qa.querySelector('.sd-qa__panel');
        var willOpen = panel.hidden;
        closeAll();
        if (willOpen) {
          panel.hidden = false;
          qa.classList.add('is-open');
          open.setAttribute('aria-expanded', 'true');
        }
        return;
      }

      var add = target.closest('[data-sd-add]');
      if (add) { e.preventDefault(); addToCart(add); return; }

      if (!target.closest('[data-sd-qa]')) closeAll();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
